import React, { useEffect, useState } from "react";
import "../Axis/Axis.css";
import axios from "../../API/axiosConfig";
import { currentLanguage } from "../../algorithms/storage";
import Chart from "react-apexcharts";
import {
  handleCatchErrors,
  responseDataFormat,
} from "../../API/middlewares/resolveRequests";
import { getEntityAxisTableData } from "../../API/services/Reports/report";
import { Link, useLocation } from "react-router-dom";
import DropDownList from "../sharedComponents/dropdown/dropdown";
import BackIcon from "../BackIcon/BackIcon";
const EntityAxis = ({ userToken }) => {
  // location
  const location = useLocation();
  const [community, setCommunity] = useState(
    location?.state?.id ? location?.state?.id : 0
  );
  const [communities, setCommunities] = useState(null);
  const getAllCommunities = async () => {
    let response;
    try {
      response = await axios.get(`Community/GetAll/1/10`, {
        headers: {
          Authorization: `Bearer ${userToken}`,
          "Accept-Language": currentLanguage(),
        },
      });
    } catch (error) {
      response = error;
    } finally {
      setCommunities(response);
    }
  };
  const [data, setData] = useState(null);
  const getAxisTable = async (userToken) => {
    let response;
    try {
      response = await axios.get(
        `Task/GetMemberChartStatusCountByCommunityId/${community}`,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
            "Accept-Language": currentLanguage(),
          },
        }
      );
    } catch (error) {
      response = error;
    } finally {
      setData(response);
    }
  };
  const [charttData, setChartData] = useState();
  const getMembersStatus = async () => {
    let response;
    try {
      response = await getEntityAxisTableData(community, userToken);
      setChartData(response);
    } catch (e) {
      response = handleCatchErrors(e);
    } finally {
      return responseDataFormat(response);
    }
  };
  const state = {
    options: {
      chart: {
        stacked: true,
        type: "bar",
        zoom: {
          enabled: false,
        },
        parentHeightOffset: 0,
        toolbar: {
          show: false,
        },
      },
      legend: {
        show: true,
        showForSingleSeries: false,
        showForNullSeries: true,
        showForZeroSeries: true,
        position: "bottom",
        horizontalAlign: "center",
        floating: false,
        fontSize: "15px",
        fontFamily: "gssLight",
        fontWeight: 400,
        formatter: undefined,
        inverseOrder: false,
        width: undefined,
        height: undefined,
        tooltipHoverFormatter: undefined,
        customLegendItems: [],
        offsetX: 0,
        offsetY: 10,
        labels: {
          colors: undefined,
          useSeriesColors: false,
        },
        markers: {
          width: 12,
          height: 12,
          strokeWidth: 0,
          strokeColor: "#fff",
          fillColors: undefined,
          radius: 12,
          customHTML: undefined,
          onClick: undefined,
          offsetX: 3,
          offsetY: 0,
        },
        itemMargin: {
          horizontal: 10,
          vertical: 10,
        },
        onItemClick: {
          toggleDataSeries: true,
        },
        onItemHover: {
          highlightDataSeries: true,
        },
      },

      markers: {
        strokeWidth: 7,
        strokeOpacity: 1,
        strokeColors: ["#fff"],
        colors: ["#00F"],
      },

      stroke: {
        curve: "straight",
      },
      // colors: ["#0085b6", "#00d39c", "#ff0000"],
      colors: ["#52bc57", "#fcc717", "#ff0000", "#3444ae"],
      xaxis: {
        crosshairs: {
          show: false,
        },
        labels: {
          rotate: 90,
          style: {
            fontSize: "18px",
            fontWeight: 600,
            fontFamily: "gssLight",
          },
          offsetY: 5,
        },
        axisBorder: {
          show: true,
          color: "#78909C",
          height: 1,
          width: "100%",
          offsetX: 0,
          offsetY: 0,
        },
        axisTicks: {
          show: true,
          borderType: "solid",
          color: "#78909C",
          height: 6,
          offsetX: 0,
          offsetY: 0,
        },
        title: {
          text: "الجهات المسئولة",
          offsetX: 0,
          offsetY: 10,
          style: {
            color: undefined,
            fontSize: 25,
            fontFamily: "gssLight",
            fontWeight: 600,
            cssClass: "apexcharts-xaxis-title",
          },
        },
        categories: charttData?.data?.data?.members?.map((item, index) => {
          return item.name;
        }),
      },
      yaxis: {
        crosshairs: {
          show: false,
        },
        labels: {
          style: {
            fontSize: "16px",
            fontFamily: "gssLight",
            fontWeight: 500,
          },
          rotate: 0,
          offsetX: 0,
          offsetY: 0,
        },
        axisBorder: {
          show: true,
          color: "#78909C",
          width: 1,
          height: "100%",
          offsetX: 5,
          offsetY: 0,
        },
        axisTicks: {
          show: true,
          borderType: "solid",
          color: "#78909C",
          height: 5,
          offsetX: 0,
          offsetY: 0,
        },
        title: {
          text: "عدد الإجراءات",
          offsetX: -140,
          offsetY: -100,
          style: {
            color: undefined,
            fontSize: 25,
            fontFamily: "gssLight",
            fontWeight: 600,
            cssClass: "apexcharts-xaxis-title",
          },
        },
      },
    },
    tooltip: {
      custom(data) {
        return `<div className='px-1 py-50'>
                    <span>${
                      data?.series[data?.seriesIndex][data?.dataPointIndex]
                    } %</span>
                  </div>`;
      },
    },

    series: [
      {
        name: "تم",
        data: charttData?.data?.data?.members?.map((item, index) => {
          return item?.tasksFinished;
        }),
      },
      {
        name: "متوقف",
        data: charttData?.data?.data?.members?.map((item, index) => {
          return item?.tasksNotStarted;
        }),
      },
      {
        name: "متأخر",
        data: charttData?.data?.data?.members?.map((item, index) => {
          return item?.tasksLate;
        }),
      },
      {
        name: "جارى",
        data: charttData?.data?.data?.members?.map((item, index) => {
          return item?.tasksCurrent;
        }),
      },
    ],
  };

  useEffect(() => {
    getAxisTable(userToken);
    getMembersStatus();
    getAllCommunities();
    if (communities) {
      communities?.data?.data?.push({
        id: 0,
        name: "",
      });
    }
  }, [community]);
  // const AllCommunities =  communities?.data?.data?.push({
  //   id:0,
  //   name:''
  // })
  const allCommunitiesArray = communities ? [...communities?.data?.data] : [];
  allCommunitiesArray?.unshift({
    id: 0,
    name: "الكل",
  });
  return (
    <div className="py-5 px-4">
      <div
        className="ctr"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          margin: "0 20px",
          position: "relative",
          zIndex: "10",
        }}
      >
        <BackIcon />
      </div>
      <div className="dropdown-search">
        <DropDownList
          dataSource={allCommunitiesArray}
          change={(e) => {
            setCommunity(e?.value);
          }}
          value={community}
          placeholder={"المحور"}
          iconName={"paperclip"}
          iconSize={16}
          containerStyle={"col-12 col-md-4 mx-3 mt-4"}
        ></DropDownList>
      </div>
      <div className="report_table">
        <table>
          <thead>
            <tr>
              <th>الجهة</th>
              <th>اجمالى عددالإجراءات</th>
              <th>تم</th>
              <th>متوقف</th>
              <th>متأخر</th>
              <th>جارى</th>
              <th>معدل الإنجاز %</th>
            </tr>
          </thead>
          <tbody>
            {data?.data?.data?.members?.map((el) => (
              <tr key={el?.id}>
                <td>
                  <Link
                    to={`/procedures/${el?.id}/${el?.name}/${community}`}
                    style={{
                      textDecoration: "none",
                      color: "black",
                    }}
                  >
                    {el?.name}
                  </Link>
                </td>
                <td>
                  <Link
                    to={`/procedures/${el?.id}/${el?.name}/${community}`}
                    style={{
                      textDecoration: "none",
                      color: "black",
                    }}
                  >
                    {el?.taskCount}
                  </Link>
                </td>
                <td>{el?.tasksFinished}</td>
                <td>{el?.tasksNotStarted}</td>
                <td>{el?.tasksLate}</td>
                <td>{el?.tasksCurrent}</td>
                <td>{el?.rate} %</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {charttData && (
        <div className="my-5">
          <Chart
            options={state.options}
            series={state.series}
            type="bar"
            // width="100%"
            height={"800px"}
          />
        </div>
      )}
    </div>
  );
};
export default EntityAxis;
